import apibase from './BaseAPI';
import lib from '../biz/lib'

const getBDInfo = async (sourceId) => {
    const url = `/userprofiles/${sourceId}`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const getPostingAccess = async (agentId) => {
    const url = `/agents/${agentId}/getPostingAccess`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const getPropStoryAccess = async (agentId) => {
    const url = `/agents/${agentId}/getPropStoryAccess`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const getPackage = async (agentId) => {
    const url = `/agents/${agentId}/getPackage`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const searchById = async (id) => {
    const param = {
        id: id
    }
    const res = await apibase.post(`/agents/id`, param);
    return res.data;
};

const login = async (credential) => {
    const url = `/agents/login`;
    try {
        const result = await apibase.post(url, credential);
        return result.data ?? null;
    } catch (err) {
        throw err;
    }
};

const forgotPassword = async (username) => {
    const params = {
        username: username
    };
    const url = '/agents/forgotPassword';
    try {
        const result = await apibase.post(url, params);
        return result.data;
    } catch (err) {
        throw err;
    }
};

// const isPlotted = async (id) => {
//     const params = {
//         id: id
//     }
//     const res = await apibase.post(`/agents/isPlotted`, params);
//     return res.data;
// };

const getEcardUrl = async (agentId) => {
    const url = `/agents/${agentId}/getEcardUrl`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const uploadImage = async params => {
    const url = `/agents/${params.id}/uploadImage`;
    let imageUri;
    try {
        const res = await apibase.post(url, params);
        imageUri = `${res.data.url}?${new Date().getTime()}`;
    } catch (err) {
        lib.log(`${url} -> ${err.response.status}`);
    }

    return imageUri;
};

const setTnc = async (agent) => {
    const url = `/agents/setTnc/${agent}`;
    try {
        const result = await apibase.post(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const save = async (agent) => {
    const res = await apibase.post(`/agents/save`, agent);
    return res.data;
};

const singleSignOn = async (secretKey) => {
    const url = `/agents/signon/${secretKey}`;
    try {
        const result = await apibase.post(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

export default {
    getBDInfo,
    getPostingAccess,
    getPropStoryAccess,
    getPackage: getPackage,
    searchById: searchById,
    login: login,
    forgotPassword: forgotPassword,
    // isPlotted: isPlotted,
    getEcardUrl: getEcardUrl,
    uploadImage: uploadImage,
    setTnc: setTnc,
    save: save,
    singleSignOn,
};

